import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { SharedFilesStore, UserStore } from '../../../stores';
import getPathToSharedFolder from './getPathToSharedFolder';
import { JUST_LOGGED_IN_TIMESTAMP_KEY, JUST_LOGGED_IN_TIMEOUT_MS } from '../Common/constants';

const usePossibleRedirectToFolder = (
    sharedFilesStore: SharedFilesStore,
    userStore: UserStore,
): void => {
    const navigate = useNavigate();

    const {
        filesPermissions,
        filesList,
        isMFARequired,
        anyRequestInProcess,
    } = sharedFilesStore;
    const MFAChecked = !isMFARequired && !anyRequestInProcess;
    const workspaceFile = filesList.find((f) => f.is_workspace);
    const possibleSingleFile = workspaceFile || (filesList.length === 1 ? filesList[0] : null);
    const hasPermissions = filesPermissions.get(possibleSingleFile?.file_id)?.summary === 'permissionsAdded';
    const isWorkspace = possibleSingleFile?.is_workspace || possibleSingleFile?.is_folder;
    const shouldMakeRedirect = isWorkspace && hasPermissions && MFAChecked;

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const hasAuthParams = urlParams.has('code') || urlParams.has('state') || urlParams.has('access_token');

        if (hasAuthParams && window.location.pathname.includes('/recipient/')) {
            sessionStorage.setItem(JUST_LOGGED_IN_TIMESTAMP_KEY, Date.now().toString());
            setTimeout(() => {
                sessionStorage.removeItem(JUST_LOGGED_IN_TIMESTAMP_KEY);
            }, JUST_LOGGED_IN_TIMEOUT_MS);
        }
    }, []);

    useEffect(() => {
        if (shouldMakeRedirect) {
            const justLoggedInTimestamp = sessionStorage.getItem(JUST_LOGGED_IN_TIMESTAMP_KEY);
            const hasJustLoggedIn = justLoggedInTimestamp
                && (Date.now() - parseInt(justLoggedInTimestamp, 10)) < JUST_LOGGED_IN_TIMEOUT_MS;

            if (!hasJustLoggedIn && possibleSingleFile) {
                const { currentUserIdentity } = userStore;
                const path = getPathToSharedFolder(currentUserIdentity, possibleSingleFile);
                navigate(path);
            }
        }
    }, [shouldMakeRedirect]);
};

export default usePossibleRedirectToFolder;
